<div class="profile-navigation">
  <div class="item" (click)="navigateToChat()">
    <p class="subtitle-14">{{ "telemedicine.navigation.chat" | translate }}</p>
  </div>

  <div class="item active">
    <p class="subtitle-14">{{ "telemedicine.navigation.history" | translate }}</p>
  </div>
</div>

<div class="tab-content">
  <div class="page-name">
    <p class="subtitle-16">{{ 'chat-history.page-title' | translate: { petName: $safeNavigationMigration(petData?.pet_name) } }}</p>
  </div>

  <div class="chat-list">
    @for (item of combinedItems; track item) {
      <div class="chat-item" (click)="openItem(item)">
        <div class="icon-part">
          @if (item.type === 'chat') {
            <mat-icon svgIcon="comment"></mat-icon>
          }
          @if (item.type === 'claim') {
            <mat-icon svgIcon="stethoscope"></mat-icon>
          }
        </div>
        <div class="content-part">
          <div class="medical-category">
            <p class="subtitle-14 chat-title">{{ item.title }}</p>
          </div>
          <div class="service-type">
            @if (item.type === 'chat') {
              <p class="body-12">{{ 'chat-history.service-type.online-vet' | translate }}</p>
            }
            @if (item.type === 'claim') {
              <p class="body-12">{{ 'chat-history.service-type.vet-visit' | translate }}</p>
            }
          </div>
          @if (item.type === 'chat') {
            <div class="consultation-date">
              <p
              class="body-12">{{ 'chat-history.dates.consultation-date' | translate }}{{ item.date | date: 'dd.MM.yyyy' }}</p>
            </div>
          }
          @if (item.type === 'claim') {
            <div class="consultation-date">
              <p class="body-12">{{ 'chat-history.dates.claim-date' | translate }}{{ item.date | date: 'dd.MM.yyyy' }}</p>
            </div>
          }
        </div>
        <div class="arrow-part">
          <mat-icon svgIcon="expand-up"></mat-icon>
        </div>
      </div>
    }
  </div>

  @if (combinedItems?.length === 0) {
    <div class="empty-item">
      <div class="icon-part">
        <mat-icon svgIcon="stethoscope"></mat-icon>
      </div>
      <div class="content-part">
        <p class="subtitle-14">{{ 'chat-history.empty-state-message' | translate }}</p>
      </div>
      <div class="arrow-part">
        <!-- Empty space to maintain layout -->
      </div>
    </div>
  }
</div>
